import { FC, forwardRef, InputHTMLAttributes, useState } from 'react';
import { Link } from 'react-router-dom';

import useTranslation from '../../customHooks/translate';

export type InputType = 'text' | 'password';

export type InputProps = {
  id: string;
  name: string;
  label: string;
  type?: InputType;
  error: any;
  hasLinkToResetPassword?: boolean;
} & InputHTMLAttributes<HTMLInputElement>;

export const Input: FC<InputProps> = forwardRef<HTMLInputElement, InputProps>(
  (
    {
      id,
      name,
      label,
      type = 'text',
      placeholder,
      error,
      autoComplete,
      hasLinkToResetPassword,
      ...props
    },
    ref
  ) => {
    const defaultStyles =
      'h-[44px] w-full rounded-md border border-[#292D3240] px-4 focus:border-ultramarine-blue focus:outline-none placeholder:text-charleston-green placeholder:opacity-25';

    const [inputType, setInputType] = useState(type);

    const translation = useTranslation();
    const switchType = () => {
      setInputType((t) => (t === 'text' ? 'password' : 'text'));
    };

    return (
      <div className="space-y-2">
        <label
          htmlFor={id}
          className="font-markpro text-sm font-medium leading-[14px] lg:text-base"
        >
          {hasLinkToResetPassword ? (
            <div className="flex items-center justify-between font-markpro text-sm">
              <div className="font-markpro text-sm font-medium leading-[14px] lg:text-base">
                {label}
              </div>
              <div>
                {hasLinkToResetPassword ? (
                  <div className="text-xs opacity-50 md:text-sm">
                    <Link to="/forgot-password">
                      {translation.login.ForgotPassword}
                    </Link>
                  </div>
                ) : null}
              </div>
            </div>
          ) : (
            label
          )}
        </label>
        <div className="relative">
          <input
            id={id}
            ref={ref}
            name={name}
            type={inputType}
            className={defaultStyles}
            placeholder={placeholder}
            autoComplete={autoComplete}
            {...props}
          />
          {type === 'password' ? (
            <div
              onClick={switchType}
              className="absolute right-4 top-[50%] h-5 w-5 translate-y-[-50%] cursor-pointer"
            >
              <img src="assets/eye.svg" alt="" />
            </div>
          ) : null}
        </div>
      </div>
    );
  }
);
